/*
 * The writing cursor's look (Settings > Writing > Cursor). The editor's own
 * caret is hidden and extensions/customCaret.ts draws this one in its place;
 * styles/caret.css holds each shape and blink.
 */

export const CARET_SHAPES = [
  { id: 'hairline', label: 'Hairline', description: 'A 1px line, like the system cursor.' },
  { id: 'bar', label: 'Bar', description: 'A slightly heavier line, easier to find on a big screen.' },
  { id: 'heavy', label: 'Heavy bar', description: 'A thick, rounded bar you can spot at a glance.' },
  { id: 'block', label: 'Block', description: 'Covers the next letter and shows it reversed out, like a terminal.' },
  { id: 'outline', label: 'Outline', description: 'An outlined box around the next letter.' },
  { id: 'underline', label: 'Underline', description: 'A line under the next letter.' },
  { id: 'point', label: 'Printing point', description: 'A small arrow under the line, where the next key will strike.' },
  { id: 'guide', label: 'Type guide', description: 'A hairline with a notch above it, after the Selectric’s type guide.' },
  { id: 'ibeam', label: 'I-beam', description: 'A line with short caps at the top and bottom.' },
  { id: 'pin', label: 'Pin', description: 'A hairline topped with a dot.' },
  { id: 'glow', label: 'Lit bar', description: 'A bar with a soft glow. Made for dark pages.' },
] as const

export type CaretShape = typeof CARET_SHAPES[number]['id']

export const CARET_BLINKS = [
  { value: 'steady', label: 'Steady' },
  { value: 'blink', label: 'Blink' },
  { value: 'fade', label: 'Fade' },
  { value: 'breathe', label: 'Breathe' },
] as const

export type CaretBlink = typeof CARET_BLINKS[number]['value']

/** Shapes that take the width of the letter after the cursor. */
export const LETTER_WIDTH_SHAPES: readonly CaretShape[] = ['block', 'outline', 'underline']

export function isCaretShape(value: unknown): value is CaretShape {
  return CARET_SHAPES.some(shape => shape.id === value)
}

export function isCaretBlink(value: unknown): value is CaretBlink {
  return CARET_BLINKS.some(blink => blink.value === value)
}
